module.exports = __webpack_public_path__ + "img/香山公园.98b2dd23.png";